// Modules
import axios from 'axios';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useSelector } from 'react-redux';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// Component
import { Pagination } from 'User/Component';
import {
  Paging, // Paging
  CurPageList, // 전체 리스트 정렬 및 현재 페이지 리스트 출력
  SetSortIco, // 정렬 아이콘 변경
  HandleSingleCheck, HandleAllCheck, // 체크박스 단일, 전체 선택
  HighlightedText, // 검색어 하이라이팅
  fileDownload
} from 'Admin/Component/AdFunc';

// API
import { AdSupportApi, AdSupportListApi, apiHost } from '_Route/Api';
import Loading from 'Admin/Component/Loading';


const AdDevSupport = () => {

  // Using Hooks
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const sanitizer = DOMPurify.sanitize;

  const [loading, setLoading] = useState(false);
  const [guideStatus, setGuideStatus] = useState(true);
  const [reqPageData, setReqPageData] = useState([]); // Req Page Data
  const [reqResData, setReqResData] = useState([]); // Req List Data

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);
  
  // Paging var
  const [curPage, setCurPage] = useState(1) // 현제 페이지
  const blockSize = 10 // Pagination 블럭 갯수
  const [pageSize, setPageSize] = useState(10) // 한 페이지에 노출할 게시물 갯수
  const [count, setCount] = useState('');

  // 필터 옵션
  const [filterOpt, setFilterOpt] = useState({
    search_key: '',
    search_val: params.key || '',
    request_cat: '',
    request_status: '',
    request_create_date: '',
    request_res_date: '',
  })
  const { search_key, search_val, request_cat, request_status, request_create_date, request_res_date } = filterOpt;

  // Column name / Sort var
  const columnList = [
    {name: 'ID', key: 'request_no'},
    {name: '회사명', key: 'request_company'},
    {name: '작성자', key: 'request_name'},
    {name: '작성자 이메일', key: 'request_email'},
    {name: '문의 제목', key: 'request_title'},
    {name: '문의 내용', key: 'request_content'},
    {name: '첨부 파일', key: 'request_file'},
    {name: '등록 일시', key: 'request_create_date'},
    {name: '서비스', key: 'request_cat'},
    {name: '처리자', key: 'request_res'},
    {name: '처리 일시', key: 'request_res_date'},
    {name: '답변 상태', key: 'request_status'},
  ]; 
  const [sortIdx, setSortIdx] = useState(0);
  const [sortType, setSortType] = useState('');
  const [sortState, setSortState] = useState('expand'); // expand, up(DECS), down(ASC);

  // CheckBox var
  const [checkItems, setCheckItems] = useState([]);


 /*========================================================================
  * onHandler Func
  ========================================================================*/
  const onFilter = (e) => {
    const { name, value } = e.target;
    setFilterOpt({...filterOpt, [name]: value});
  }

  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/admin/dev-support/list${search_val === '' ? '' : '/' + encodeURIComponent(search_val)}`);
  }


  /* ========================================================================
  * Axios Req
  ========================================================================*/
  const [update, setUpdate] = useState(false); // 리스트 상태 업데이트 변수 

  // Set Req List
  useEffect(() => {
    setLoading(false)
    axios.get(AdSupportListApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: filterOpt
    })
    .then(res => {
      // console.log("GET Support Request Success!", res);
      const sortData = res.data.result;
      
      setReqPageData(res.data.pageInfo)
      setReqResData(CurPageList(sortData, sortType, sortState, curPage, pageSize))
      setCount(res.data.result.length);
    })
    .catch(err => {
      console.error("GET Support Request ERROR...", err);
    })
    .finally(() => {
      setLoading(true)
    })
  }, [location, pageSize, curPage, sortState, sortIdx, update, search_key, request_cat, request_status, request_create_date, request_res_date])

  // DELETE Req
  const DeleteReq = (requestUuid, index) => {
    axios({
      url: AdSupportApi,
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        request_uuid: requestUuid,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      // console.log("DELETE Support Request Success!", res);
      if(index === checkItems.length - 1) {
        alert(`${checkItems.length}개의 문의 내역 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      }
      setUpdate(!update)
    })
    .catch(err => {
      console.error("DELETE Support Request ERROR...", err);
      const errMsg = err.response.data.message
      if (errMsg && index === 0) { alert(errMsg); }
    })
  }
  
  // 일괄 삭제 함수
  const deleteFunc = () => {
    if(checkItems.length === 0) {
      alert('삭제할 문의 내역을 선택해주세요.')
    } else {
      if(window.confirm(`${checkItems.length}개의 문의 내역을 선택하셨습니다. \n정말 삭제${master === 1 ? '' : '를 요청'}하시겠습니까?`)) {
        checkItems.map((id, i) => { DeleteReq(id, i) })
        setCheckItems([])
      }
    }
  }

  
  return (
    <>
      <div className="adContTitGroup">
        <h2>문의 내역 관리</h2>
        <p>Home / Dev Support / 문의 내역 관리 <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>

        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* 문의 내역을 <span className="blueTxt">조회/관리</span>할 수 있습니다.</li>
          <li>* 답변하기 버튼을 통해 문의자에게 답변을 보낼 수 있습니다.</li>
        </ul> 
      </div>

      <div className="adContArea list">

        <div className="flexBox between">
          <div className="adListBox">
            {
              userScore >= 300 &&
              <button type="button" className="btn xs red round_10" onClick={deleteFunc}>선택 삭제</button>
            }
            
            <div className="fieldGroup">
              <label>노출 게시물 수</label>

              <div className="field">
                <select className="select sm type_1 round_10" onChange={(e) => setPageSize(e.target.value)} defaultValue="10">
                  <option value="10">10개 씩</option>
                  <option value="30">30개 씩</option>
                  <option value="50">50개 씩</option>
                  <option value="100">100개 씩</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>서비스</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="request_cat" onChange={(e) => onFilter(e)}>
                  <option value="">전체 서비스</option>
                  <option value="Seyfert Remittance">Seyfert Remittance</option>
                  <option value="Seyfert P2P">Seyfert P2P</option>
                  <option value="Seyfert PG">Seyfert PG</option>
                  <option value="Seyfert Wallet">Seyfert Wallet</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>답변 상태</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="request_status" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="0">미답변</option>
                  <option value="1">답변 완료</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>작성 일시</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="request_create_date" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>처리 일시</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="request_res_date" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>
          </div>

          <div className="adListBox">
            <div className="fieldGroup row gap">
              <label>문의 검색</label>

              <div className="field gap">
                <select className="select sm type_1 round_10" name="search_key" onChange={(e) => onFilter(e)}>
                  <option value="">통합검색</option>
                  <option value="request_title">문의 제목</option>
                  <option value="request_content">문의 내용</option>
                  <option value="request_company">회사명</option>
                  <option value="request_name">작성자</option>
                  <option value="request_email">작성자 이메일</option>
                  <option value="request_res">처리자</option>
                </select>
                <div className="inputIco">
                  <input type="text" className="input sm type_1 i_rt round_10" name="search_val" value={search_val} onChange={(e) => onFilter(e)} onKeyPress={onKeyPress} placeholder="검색어를 입력해주세요." />
                  <button type="button" className="icofont-search" onClick={onSearch}></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="table list_2">
          <table>
            <thead>
              <tr>
                <th className="check">
                  <div className="checkGroup">
                    <input type="checkbox" className='check sm blue' id="allCheck" onChange={(e) => setCheckItems(HandleAllCheck(e.target.checked, reqResData, 'request_uuid'))} checked={checkItems.length === reqResData.length ? true : false}/>
                    <label htmlFor="allCheck"></label>
                  </div>
                </th>
                {columnList.map((list, i) =>
                  <th key={i} onClick={() => {setSortState(SetSortIco(i, sortIdx, sortState)); setSortIdx(i); setSortType(list.key)}}>{list.name}<i className={`icofont-rounded-${i === sortIdx ? sortState : 'expand'}`}></i></th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ?
                reqResData.length !== 0 ?
                  reqResData.map((data, i) => 
                    <tr key={i}>
                      <td>
                        <div className="checkGroup">
                          <input type="checkbox" className='check sm blue' id={`check_${i}`} onChange={(e) => setCheckItems(HandleSingleCheck(e.target.checked, data.request_uuid, checkItems))} checked={checkItems.includes(data.request_uuid) ? true : false}/>
                          <label htmlFor={`check_${i}`}></label>
                        </div>
                      </td>
                      <td>{data.request_no}</td>
                      <td>{data.request_company}</td>
                      <td>{data.request_name}</td>
                      <td>{data.request_user_email}</td>
                      <td style={{minWidth: '150px', maxWidth: '300px'}} dangerouslySetInnerHTML={{ __html: sanitizer(data.request_title)}}></td>
                      <td><div className="innerBox" style={{minWidth: '250px', maxWidth: '400px'}} dangerouslySetInnerHTML={{ __html: sanitizer(data.request_content)}}></div></td>
                      <td><button type="button" className="fileLink" title="파일 다운로드" onClick={() => fileDownload('support/request', data.request_file)}>{data.request_file ?? '-'}</button></td>
                      <td>{moment(data.request_create_date).format('YYYY-MM-DD HH:mm')}</td>
                      <td>{data.request_cat}</td>
                      <td>{data.request_res ? data.request_res : '-'}</td>
                      <td>{data.request_res_date ? moment(data.request_res_date).format('YYYY-MM-DD HH:mm') : '-'}</td>
                      <td style={{width: '125px'}}>
                        <div className="btnArea full">
                          {
                            userScore >= 200 ?
                            <button type="button" className={`btn xxs ${data.request_status === 0 ? 'blue_edge' : 'green'} round_10`} onClick={() => navigate(`/admin/dev-support/replay-mail/${data.request_uuid}`)}>{data.request_status === 0 ? '답변하기' : '답변 완료'}</button>
                            :
                            <button type="button" className="btn xxs blue_edge round_10">미답변</button>
                          }
                        </div>
                      </td>
                    </tr>
                  )
                  :
                  <tr>
                    <td colSpan={columnList.length + 1}>
                      <div className="noData">
                        <i className="icofont-warning-alt"></i>
                        <p>데이터가 존재하지 않습니다.</p>
                      </div>
                    </td>
                  </tr>
                :
                <tr><td colSpan={columnList.length + 1}><Loading type="tbLoad" /></td></tr>
              }
            </tbody>
          </table>
        </div>

        <div className="flexBox between paginationBox">
          <p>Showing {curPage} to {pageSize} of {reqPageData.count} entries</p>

          <Pagination
            type="type_1"
            size="sm"
            curPage={curPage}
            setCurPage={setCurPage}
            pageSize={pageSize}
            blockSize={blockSize}
            startBlock={Paging(curPage, blockSize, pageSize, count).startBlock}
            endBlock={Paging(curPage, blockSize, pageSize, count).endBlock}
            pageCount={Paging(curPage, blockSize, pageSize, count).pageCount}
          />
        </div>
      </div>
    </>
  )
}

export default AdDevSupport;